
import { Component, Mixins } from 'vue-property-decorator';
import CustomizeTooltip from '@/features/dashboard/components/CustomizeTooltip.vue';
import { Widget } from '@/features/dashboard/types';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    CustomizeTooltip,
  },
})
export default class WidgetControls extends Mixins(ResponsivenessMixin) {
  get widgets(): Array<Widget> {
    return this.$store.getters.getWidgets as Array<Widget>;
  }

  get showToggleTooltip(): boolean {
    return this.$store.getters.getShowCustomizeTooltip
      && this.$store.getters.getCustomizeTooltipStep === 3;
  }

  private closeTooltip(): void {
    this.$store.commit('setShowCustomizeTooltip', false);
    this.$store.commit('setCustomizeTooltipStep', 1);
  }

  private toggleWidget(value: boolean, key: string, widget: Widget): void {
    let { position } = widget;
    let method: 'push' | 'pop' = 'pop';

    if (value) {
      position = this.getPositionOfLastWidget(widget.size) + 1;
      method = 'push';
    }

    this.$store.commit('updateWidgetSettings', {
      dashboardWidget: key,
      visible: value,
      position,
      itemsShown: widget.itemsShown,
      customSettings: widget.customSettings,
    });

    eventBus.$emit(eventNames.UPDATE_DASHBOARD_WIDGETS_COLUMN, {
      method,
      widgetName: key,
      size: widget.size,
    });
  }

  private getPositionOfLastWidget(size: 'big' | 'small'): number {
    const widgetElements = Object.entries(this.widgets).map((el) => {
      return {
        ...el[1],
      };
    });

    const widgets = widgetElements.filter(
      (widget) => widget.show === true && widget.size === size,
    );

    if (!widgets || !widgets.length) return 0;

    return widgets.sort((a, b) => {
      return a.position - b.position;
    })[widgets.length - 1].position;
  }
}
